// extracted by mini-css-extract-plugin
export default {"col":"dcc_summaryTable-col","valueCol":"dcc_summaryTable-valueCol","figure":"dcc_summaryTable-figure"};